import React from "react";

/**
 * Pick2Play brand mark.
 * Two visual modes:
 *  - withText=true (default): full lockup PNG (icon + "pick2play" wordmark, dark bg).
 *    Uses /brand-lockup.png — height-driven so it scales cleanly in the header.
 *  - withText=false: just the icon-only square (used in tight spaces, avatars, og preview).
 */
const LOCKUP_SRC = "/brand-lockup.png";
const ICON_SRC = "/icon-192.png";

export default function Logo({ size = 36, withText = true, className = "" }) {
  if (withText) {
    // Full lockup: dictate by height; width auto via CSS aspect ratio.
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo">
        <img
          src={LOCKUP_SRC}
          alt="Pick2Play"
          height={size}
          style={{ height: size, width: "auto" }}
          className="block select-none"
          draggable={false}
        />
      </div>
    );
  }
  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo-icon">
      <img
        src={ICON_SRC}
        alt="Pick2Play"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-lg object-contain"
        draggable={false}
      />
    </div>
  );
}
